import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, nightOwl, vsDark } from "@code-surfer/themes";
const styledCenter = {
  width: "fit-content",
  textAlign: "center",
  borderBottom: '10px solid',
  borderImageSource: "linear-gradient(120deg, #1890ff, #db18ff)",
  borderImageSlice: 5
};
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CodeSurferColumns themes={[nightOwl]} mdxType="CodeSurferColumns">
      <Step mdxType="Step">
        <div style={styledCenter}>
          <h1> useCallback</h1>
          <p>Preserve functions state</p>
        </div>
        <pre><code parentName="pre" {...{
            "className": "language-jsx"
          }}>{`function ProductPage({ productId }) {
  // ✅ Wrap with useCallback to avoid change on every render
  const fetchProduct = useCallback(() => {
    // ... Does something with productId ...
  }, [productId]); // ✅ All useCallback dependencies are specified

  return <ProductDetails fetchProduct={fetchProduct} />;
}

function ProductDetails({ fetchProduct }) {
  useEffect(() => {
    fetchProduct();
  }, [fetchProduct]); // ✅ All useEffect dependencies are specified
  // ...
}
`}</code></pre>
      </Step>
      <Step mdxType="Step">
        <div style={styledCenter}>
          <h1> useCallback</h1>
          <p>Preserve functions state</p>
        </div>
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "2:5",
            "2:5": true
          }}>{`function ProductPage({ productId }) {
  // ✅ Wrap with useCallback to avoid change on every render
  const fetchProduct = useCallback(() => {
    // ... Does something with productId ...
  }, [productId]); // ✅ All useCallback dependencies are specified

  return <ProductDetails fetchProduct={fetchProduct} />;
}

function ProductDetails({ fetchProduct }) {
  useEffect(() => {
    fetchProduct();
  }, [fetchProduct]); // ✅ All useEffect dependencies are specified
  // ...
}
`}</code></pre>
      </Step>
      <Step mdxType="Step">
        <div style={styledCenter}>
          <h1> useCallback</h1>
          <p> Referential Equality </p>
        </div>
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "10:13",
            "10:13": true
          }}>{`function ProductPage({ productId }) {
  // ✅ Wrap with useCallback to avoid change on every render
  const fetchProduct = useCallback(() => {
    // ... Does something with productId ...
  }, [productId]); // ✅ All useCallback dependencies are specified

  return <ProductDetails fetchProduct={fetchProduct} />;
}

function ProductDetails({ fetchProduct }) {
  useEffect(() => {
    fetchProduct();
  }, [fetchProduct]); // ✅ All useEffect dependencies are specified
  // ...
}
`}</code></pre>
      </Step>
    </CodeSurferColumns>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      